module.exports = __webpack_public_path__ + "public/img/ttd-bina-insani.8d3f562d.png";